import { Component, inject } from '@angular/core';
import { ContractTypeGroupService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeGroupCreateDto,
  ContractTypeGroupDto,
  ContractTypeGroupExcelDownloadDto,
  ContractTypeGroupUpdateDto,
} from '../proxy/controlling/dtos/contract-type-group';
import { CONTRACTTYPEGROUP_CONFIG, CONTRACTTYPEGROUP_FIELDS } from './contract-type-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeGroupService, ConfirmationService],
  templateUrl: './contract-type-group.html',
  styleUrl: './contract-type-group.scss',
})
export class ContractTypeGroup extends BaseCrudComponent<
  ContractTypeGroupDto,
  ContractTypeGroupCreateDto,
  ContractTypeGroupUpdateDto,
  ContractTypeGroupExcelDownloadDto
> {
  service = inject(ContractTypeGroupService);
  config = CONTRACTTYPEGROUP_CONFIG;
  fields = CONTRACTTYPEGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeGroupDto): ContractTypeGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      contractMasterGroupId: data.contractMasterGroupId,
      processId: data.processId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeGroup';
  }
}
